import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ChatMessageUtilService {
  processContent(content: string) {
    return content.replace(/((<\/?(?:p|img)[^>]*>)|(<[^>]+>)(<!<br>)) /gi, '');
  }

  processUrl(content: string) {
    let replacedText = content.replace(/((<\/?(?:p|img)[^>]*>)|(<[^>]+>)(<!<br>)) /gi, '');
    const urlRegex = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/g;
    return replacedText.replace(urlRegex, url => '<a href="' + url + ' " target=_blank"">' + url + '</a>');
  }
}
